import axios from "axios";
import { backendurl } from "./baseurl.js";

axios.defaults.baseURL = backendurl;
